import script from "./OpenTranslationProjectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenTranslationProjectModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__